import { 
    PROFILE_UPDATE,
    PROFILE_READ    
} from "../../constants/action-types";

export function profileUpdate(data){
    return { type: PROFILE_UPDATE, payload: data } }

export function profileRead(){
    return { type: PROFILE_READ } }




// WEBPACK FOOTER //
// ./src/store/actions/profile.js